import { render } from "./ClientesInviertenNew.vue?vue&type=template&id=a11c9990&scoped=true"
import script from "./ClientesInviertenNew.vue?vue&type=script&lang=js"
export * from "./ClientesInviertenNew.vue?vue&type=script&lang=js"

import "./ClientesInviertenNew.vue?vue&type=style&index=0&id=a11c9990&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11c9990"]])

export default __exports__